import { downloadFileWithReportKey, loadFileWithReportKey } from '@faceup/crypto'
import { AudioPlayer } from '@faceup/ui'
import type { ReactNode } from 'react'
import type { Attachment } from './FormItemsAnswers'

type VoiceMessagePlayerProps = {
  attachment: Attachment
  encryptionKey: string
  label: ReactNode
  disabled?: boolean
  onError?: (error: unknown, action: 'play' | 'download') => void
}

export const VoiceMessagePlayer = ({
  attachment,
  encryptionKey,
  label,
  disabled = false,
  onError,
}: VoiceMessagePlayerProps) => (
  <AudioPlayer
    label={label}
    onPlay={
      !disabled
        ? async () => {
            const result = await loadFileWithReportKey(attachment, encryptionKey)
            if (result.isErr()) {
              onError?.(result.error.exception, 'play')
              throw new Error('Failed to load voice message')
            }
            return URL.createObjectURL(result.value)
          }
        : undefined
    }
    onDownload={
      !disabled
        ? async () => {
            const result = await downloadFileWithReportKey(attachment, encryptionKey)
            if (result.isErr()) {
              onError?.(result.error.exception, 'download')
            }
          }
        : undefined
    }
  />
)
